import { render, staticRenderFns } from "./BatchRunItem.vue?vue&type=template&id=63781768&scoped=true"
import script from "./BatchRunItem.vue?vue&type=script&lang=js"
export * from "./BatchRunItem.vue?vue&type=script&lang=js"
import style0 from "./BatchRunItem.vue?vue&type=style&index=0&id=63781768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63781768",
  null
  
)

/* custom blocks */
import block0 from "../CustomerOrder/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FBatchRun%2FBatchRun%2FBatchRunItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports